import React, { useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import { Node, ViewFilters, useViewFilterQuery } from '@uncinc/react-drupal-core';

import Pager from '../../../components/Pager';
import ViewFilter from '../../../components/ViewFilter';

import './style.scss';

const ViewLatestPointsOfView = (props) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const viewIsLoaded = useRef(null);
  const { entities, pager, filters } = props;
  const totalPages = pager.get('total_pages');
  const { page, setCurrentPage, setFilters } = useViewFilterQuery();

  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const isLoading = useMemo(() => {
    return page !== pager.get('current_page');
  }, [page, pager]);

  const ViewClasses = c('ViewLatestPointsOfView', {
    'ViewLatestPointsOfView--no-pager': totalPages <= 1,
    'ViewLatestPointsOfView--loading': isLoading,
  });

  return (
    <div className={ViewClasses} ref={ref}>
      <Container>
        <FormikWrapper>
          <ViewFilters
            viewId="latest_points_of_view"
            display="default"
            onFilterUpdate={(field, value) => {
              setFilters({
                ...filters,
                [field]: value,
              });
            }}
            onRender={(data) => (
              <ViewFilter {...data} filters={filters} />
            )}
          />
        </FormikWrapper>

        {entities.size !== 0 ? (
          <>
            <div className="row">
              {entities.map((entity) => {
                const id = entity.getIn(['nid', 0, 'value']);
                const uuid = entity.getIn(['uuid', 0, 'value']);
                return (
                  <div key={uuid} className="col-12">
                    <Node
                      id={id}
                      entity={entity}
                      viewMode="teaser"
                    />
                  </div>
                );
              })}
            </div>
            <div className="ViewLatestPointsOfView__pager">
              <Pager
                currentPage={page + 1}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
                correctSetter={false}
              />
            </div>
          </>
        ) : (
          <Container>
            <div className="View__no_results">
              <div className="View__no_results__title">
                {t('filters.no_results')}
              </div>
            </div >
          </Container >
        )}

      </Container>
    </div>
  );
};

export default ViewLatestPointsOfView;
